import Nav from '../components/common/Nav';
import Footer from '../components/common/Footer';
import SEO from '../components/common/SEO';

export default function About() {
  return (
    <>
      <SEO 
        title="About"
        description="Estonian entrepreneur based in New York. Co-founder of Ready Player Me. Angel investor helping early-stage founders."
        url="/about"
      />
      <Nav />
      
      <header style={{ padding: 0, margin: 0, minHeight: 'auto' }}>
        <div className="container" style={{ paddingTop: '96px', paddingBottom: 0 }}>
          <div className="section-header">
            <h1 style={{ fontSize: '32px', marginTop: 0, marginBottom: '15px', padding: '3px 2px', lineHeight: 1.3 }}>
              About me
            </h1>
          </div>
        </div>
      </header>

      <section className="about" style={{ borderTop: 'none' }}>
        <div className="container">
          <div className="content">
            <p>Hey there 👋</p>
            <p>I'm Kaspar Tiri.</p>
            <p>
              I'm an Estonian entrepreneur based in New York. I love building products, 
              finding creative ways to take them to market, and sharing what I learn along the way.
            </p>
            <p>
              In 2014, I co-founded Ready Player Me with three friends. We were 19 and 20 years old, 
              from a small town in Estonia. We knew nothing about building tech startups, but we were obsessed with 
              avatars and the idea of a persistent digital identity.
            </p>
            <p>
            In the early days, we built several hardware products. My favorite was an <a href="https://www.reuters.com/article/technology/estonian-firms-3d-photo-pod-promises-personalized-vr-avatars-idUSKBN13A1ON/" target="_blank" rel="noopener noreferrer">egg-shaped 3D scanner booth</a> that 
            we installed in airports and malls around the world. We scanned tens of thousands of people and used that data 
            to train a system that could generate avatars from a single selfie. That tech let us pivot away from hardware and 
            opened the door to enterprise clients like Tencent, Huawei, HTC, and many others. After years of building custom avatar tech, 
            we launched a cross-game avatar platform in 2020. 
            </p>
            <p>
            The platform served 150,000+ developers and delivered over 200 million avatars. We raised $72M from a16z, 
            Plural, and angels including the founders of Roblox, Twitch, and King Games. In 2025, Ready Player Me was acquired by Netflix.
             Somewhere along the way, I was named <a href="https://www.forbes.com/pictures/5c60c0f2a7ea432d0765b2fe/wolf3d-rainer-selvet-kasp/" target="_blank" rel="noopener noreferrer">Forbes 30 Under 30</a>.
            </p>
            <p>These days, I build stuff for fun, angel invest, and help founders figure things out. 
            </p>
            <p>When I'm not working, you'll find me surfing or hiking.</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

